var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLobbyClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.867 1.3999L8.6633 6.29409C8.5959 6.37331 8.58071 6.4845 8.6244 6.5789C8.66808 6.67331 8.76267 6.73369 8.86669 6.73358H10.7335V11.0005L14.9364 6.10634C15.0037 6.02721 15.019 5.91619 14.9755 5.82185C14.932 5.72751 14.8376 5.66702 14.7337 5.66685H12.867V1.3999Z",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73296 9.26646C5.91124 9.26646 6.86643 8.31127 6.86643 7.13298C6.86643 5.9547 5.91124 4.99951 4.73296 4.99951C3.55468 4.99951 2.59949 5.9547 2.59949 7.13298C2.59949 8.31127 3.55468 9.26646 4.73296 9.26646Z",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46654 14.0668C8.46654 12.0048 6.79496 10.3332 4.73297 10.3332C2.67097 10.3332 0.99939 12.0048 0.99939 14.0668V15.6669H2.59949L3.13286 21.0006H6.33307L6.86644 15.6669H8.46654V14.0668Z",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.733 9.26646C19.9112 9.26646 20.8664 8.31127 20.8664 7.13298C20.8664 5.9547 19.9112 4.99951 18.733 4.99951C17.5547 4.99951 16.5995 5.9547 16.5995 7.13298C16.5995 8.31127 17.5547 9.26646 18.733 9.26646Z",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4665 14.0667C22.4665 12.0047 20.795 10.3331 18.733 10.3331C16.671 10.3331 14.9994 12.0047 14.9994 14.0667V15.6668H16.5995L17.1329 21.0005H20.3331L20.8664 15.6668H22.4665V14.0667Z",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobbyClicked);
export default __webpack_public_path__ + "static/media/Lobby_clicked.fef888ebc0772fc3edeaec16c5e2abb7.svg";
export { ForwardRef as ReactComponent };